import React from "react";

export const PageHeader = props => {
	return (
		<div className="PageHeader">
			<div className="dx-col">
				<header>{props.title}</header>
				<div className="header-info">{props.subtitle}</div>
				<div className="header-accent" />
			</div>
			<div>
			    {/* <p>PCG Express Pay is a web portal provided by the AIG Private Client Group (“PCG”), a division of the member companies of American International Group, Inc. (“AIG”), and accessed via a user's Internet browser on a computer or mobile device through which the user may interact with the PCG Express Pay platform to make a payment or manage an insurance policy. </p> */}
      </div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PageHeader/PageHeader.js